import { Navigate } from 'react-router-dom';
import { useAgentSelector } from '../../auth/AgentSelectorContext';

/**
 * Redirects /app/audit → /app/agents/:selectedAgentId/audit
 * so the sidebar link works without hardcoding an agentId.
 */
export function AuditRedirect() {
  const { selectedAgentId } = useAgentSelector();
  if (!selectedAgentId) return <Navigate to="/app/agents" replace />;
  return <Navigate to={`/app/agents/${selectedAgentId}/audit`} replace />;
}
